/**
 * The building register, and the one side effect that makes it real.
 *
 * The thirty facilities are not a separate list the buildings screen owns —
 * they are pushed into the asset base on load, so search, work orders,
 * inspections, the section grid and the 3D view all pick them up once a pin
 * exists. Importing this module performs that merge, which is why the domain
 * imports it for its effect and not only for its data.
 *
 * Miss it and the survey has 1,014 assets instead of 1,044, `byId["F12"]` is
 * undefined, and every check of the form "has this facility ever been
 * inspected" silently answers no-such-asset rather than never — which reads on
 * the board as a system in good order.
 *
 * Hand-ported rather than generated: the literal ends in a `.map()`, and the
 * push that follows it is a top-level statement, so neither survives a walker
 * that follows declarations.
 */
import { ASSETS, byId } from "./tables";
import { FACILITY_ROWS } from "../../domain/facilityRegister";

type Row = [string, string, string, string, number, boolean?];

/* the rows live in domain/facilityRegister.ts, shared with the facility inspections */
const ROWS: Row[] = FACILITY_ROWS;

export interface Facility {
  id: string;
  name: string;
  group: string;
  domain: string;
  crit: number;
  /** an area rather than a point — civil works cover ground, they do not sit on it */
  area: boolean;
  cat: string;
  system: string;
  source: string;
  E: number | null;
  N: number | null;
  lat: number | null;
  lon: number | null;
}

export const FACILITIES: Facility[] = ROWS.map((r) => ({
  id: r[0],
  name: r[1],
  group: r[2],
  domain: r[3],
  crit: r[4],
  area: !!r[5],
  cat: "BLDG",
  system: r[2],
  source: "register",
  E: null,
  N: null,
  lat: null,
  lon: null,
}));

/* they join the asset base, so search, work orders, inspections, the 3D view
   and the section grid all pick them up once a pin exists */
for (const f of FACILITIES) {
  if (!byId[f.id]) {
    ASSETS.push(f);
    byId[f.id] = f;
  }
}

export const FGROUPS: string[] = [...new Set(FACILITIES.map((f) => f.group))];
